module.exports = __webpack_public_path__ + "img/icon_logo.09b66b3c.png";